import { createZodDto } from 'nestjs-zod/dto';
import { CommonInvitationCreateSchema } from './common-invitation-create.schema';
export const GuestInvitationCreateSchema = CommonInvitationCreateSchema.required({
    ePrivateKeyBySsoSecret: true,
});
export class GuestInvitationCreateDto extends createZodDto(GuestInvitationCreateSchema) {
}
